import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Table, IconButton, Icon, Form, Button } from 'rsuite'
import { useForm } from 'react-hook-form'
import { isEmpty } from 'lodash-es'
import moment from 'moment'
import classNames from 'classnames'
import {
  saveSubYearAndDataNew,
  saveSubCost,
  saveSubDetailNew,
  deleteSubPeriodNew,
} from '../../../redux/actions/paymentSave'
import { startLoading, doneLoading } from '../../../utils/loading'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import notification from '../../../utils/notification'
import EditYearCell from '../../../components/cell/EditYearCell'
import EditDateCell from '../../../components/cell/EditDateCell'
import EditNumberCell from '../../../components/cell/EditNumberCell'
import EditEditorCell from '../../../components/cell/EditEditorCell'
import {
  totalData,
  getExpandedId,
  convertTableData,
  subProjectConvertTableData,
  initialNewData,
  getTotalSummary,
  getNewDataEditYearAndDate,
  getNewCostDataEditState,
  getNewDetailDataEditState,
  subProjectInitialNewData,
  getExpandedAllId,
  getSubNewCostDataEditState,
} from './PeriodExpensesUtils'
import { dateAndYearValidation } from './Validation'
import './styles.less'
import { budgetFormat } from '../../../utils/formatterUtil'
import { Controller } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import {
  isValidators,
  isRequired,
  getMaxLengthData,
  requiredFiled,
  isImageOrPdf,
} from '../../../utils/ValidatorUtils'

const { Column, HeaderCell, Cell } = Table

export default function PeriodExpenses({
  header,
  data,
  initialData,
  initialInstallment,
  isEditable,
  isCollapseAllTableRow,
  onChangeBudget,
  projectVersionId,
  startProjectDate,
  endProjectDate,
  isMulti,
  onMultiSave = () => {},
  isAssociate,
  widgetControl,
  widgetErrors,
  onWithdrawAmountChange,
  isWithdrawRequestSub,
  disabledForm,
  activityBudget,
  isValidateBudget
}) {
  const { register, handleSubmit, errors, control, setError, clearErrors } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [tableData, setTableData] = useState()
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [requestDeleteData, setRequestDeleteData] = useState()
  const [isMultiSaveError, setIsMultiSaveError] = useState(false)
  const [masterInitialData, setMasterInitialData] = useState(initialData)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (isEmpty(data)) {
      return
    }
    var newData
    if (isWithdrawRequestSub) {
      newData = convertTableData(data, isEditable, masterInitialData)
    } else {
      newData = subProjectConvertTableData(data, isEditable, false)
    }

    setTableData([...newData, totalData])
    if (!isCollapseAllTableRow) {
      setExpandedRowKeys(getExpandedAllId(newData))
    }
  }, [data, isCollapseAllTableRow, isEditable])

  const showSaveError = (key, text) => {
    setError(key, {
      type: 'manual',
      message: text,
    })
    notification.open('error', {
      key: key,
      title: text,
      duration: 10000,
    })
  }

  const handleOnClickAddNewData = () => {
    let dataWithoutTotal = []
    if (!isEmpty(tableData)) {
      dataWithoutTotal = tableData.slice(0, -1)
    }
    const addedData = subProjectInitialNewData(
      masterInitialData,
      initialInstallment,
      dataWithoutTotal
    )
    setTableData((state) => {
      if (state) {
        const dataWithoutTotal = state.slice(0, -1)
        return [...dataWithoutTotal, addedData, totalData]
      }
      return [addedData, totalData]
    })

    const newIds = getExpandedAllId([addedData])

    setExpandedRowKeys((state) => [...state, ...newIds])
  }

  const handleEditState = (rowData, value, isEditValue = false, _onChangeBudget = () => {}) => {
    if (rowData.isDetail) {
      const nextData = getNewDetailDataEditState(tableData, rowData, value, isEditValue)
      setTableData(nextData)
      return
    }

    const nextData = getSubNewCostDataEditState(tableData, rowData, value, isEditValue)
    setTableData(nextData)
    _onChangeBudget(getTotalSummary(nextData), nextData.slice(0, nextData.length - 1))
  }

  const handleEditYearAndDate = (
    rowData,
    year,
    date,
    startDate,
    endDate,
    cost,
    isEditValue = false,
    _onChangeBudget = () => {}
  ) => {
    console.log('handleEditYearAndDate')
    const nextData = getNewDataEditYearAndDate(
      tableData,
      rowData,
      year,
      date,
      startDate,
      endDate,
      cost,
      isEditValue
    )
    setTableData(nextData)
    _onChangeBudget(getTotalSummary(nextData))
  }

  const handleCallApiSaveCost = async (request, rowData, data) => {
    startLoading()
    try {
      if (!isMulti) {
        const _schema = await saveSubCost(request, projectVersionId || projectId)
      }
      handleEditState(rowData, [data[`vat_${rowData.id}`], data[rowData.id]], true, onChangeBudget)
    } catch (e) {
      notification.open('error', {
        title: 'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
        duration: 10000,
      })
    }
    doneLoading()
  }

  const handleCallApiSaveDetail = async (request, rowData, data) => {
    startLoading()
    try {
      if (!isMulti) {
        const _schema = await saveSubDetailNew(
          request,
          projectVersionId || projectId,
          rowData._parent?._parent?.id
        )
      }
      handleEditState(rowData, data[rowData.id], true)
    } catch (e) {
      notification.open('error', {
        title: 'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
        duration: 10000,
      })
    }
    doneLoading()
  }

  const handleSave = (data, rowData) => {
    console.log('handleSave')
    if (rowData.isDetail) {
      console.log('handleCallApiSaveDetail')
      const request = {
        detail: data[rowData.id],
      }
      handleCallApiSaveDetail(request, rowData, data)
    } else {
      console.log('handleCallApiSaveCost')
      const request = {
        categoryOfCostId: rowData._parent._parent.id,
        categoryCostId: rowData.id,
        cost: data[rowData.id],
        vat: rowData.vat,
        tax: rowData.tax,
      }
      handleCallApiSaveCost(request, rowData, data)
    }
  }

  const handleCallApiSaveYearAndDate = async (request, rowData, year, date, startDate, endDate) => {
    startLoading()
    try {
      if (!isMulti) {
        console.log('request', request)
        const _schema = await saveSubYearAndDataNew(request, projectVersionId || projectId)
      }
      handleEditYearAndDate(rowData, year, date, startDate, endDate, request.cost, true, onChangeBudget)
      const isNewInstallment = !rowData.year || !rowData.date
      if (isNewInstallment && rowData.children) {
        rowData.children.forEach((element) => {
          element.children.forEach((childRowData) => {
            handleEditState(childRowData)
          })
        })
      }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
        duration: 10000,
      })
    }
    doneLoading()
  }

  const handleSaveYearAndDate = (data, rowData) => {
    console.log('handleSaveYearAndDate')
    const year = data[`year_${rowData.id}`]
    const date = data[`date_${rowData.id}`]
    const startDate = data[`startDate_${rowData.id}`]
    const endDate = data[`endDate_${rowData.id}`]
    const cost = data[`cost_${rowData.id}`]

    const isInvalid = dateAndYearValidation(
      showSaveError,
      tableData,
      rowData,
      year,
      date,
      startDate,
      endDate,
      startProjectDate,
      endProjectDate
    )
    if (isInvalid) return

    var defaultYear = new Date().getFullYear() + 543
    if (new Date().getMonth() >= 9) {
      defaultYear = new Date().getFullYear() + 543 + 1 //ปีงบประมาณ = ปีปัจุบัน+1 (เดือน 10 11 12)
    }

    const request = {
      categoryOfCostId: rowData.id,
      numberOfInstallment: rowData.numberOfInstallment,
      date: moment(date).format('DD/MM/YYYY'),
      startDate: moment(startDate).format('DD/MM/YYYY'),
      endDate: moment(endDate).format('DD/MM/YYYY'),
      budgetYear: defaultYear,
      cost: cost
    }

    //validate budget
    if(isValidateBudget){
      var newTotalBudget = cost
      tableData.forEach((item) => {
        if(item.id != rowData.id){
          newTotalBudget += item.cost
        }
      })

      if(newTotalBudget > activityBudget){
        notification.open('error', {
          title: `จำนวนเงินรวม มากกว่างบประมาณกิจกรรม (เกินมา ${parseFloat(newTotalBudget-activityBudget).toFixed(2)} บาท) `,
          duration: 5000,
        })
        return
      }
    }

    handleCallApiSaveYearAndDate(request, rowData, defaultYear, date, startDate, endDate)
  }

  const handleCallApiDeleteCost = async (rowData) => {
    startLoading()
    try {
      if (!isMulti) {
        const _schema = await deleteSubPeriodNew(projectVersionId || projectId, rowData.id)
      }
      const removedData = [...tableData.slice(0, -2)]
      onChangeBudget(getTotalSummary(removedData))
      setTableData([...removedData, totalData])
    } catch (e) {
      notification.open('error', {
        title: 'ลบงวดไม่สำเร็จ',
        duration: 10000,
      })
    }
    doneLoading()
  }

  const handleDelete = (rowData) => {
    if (!rowData.year || !rowData.date) {
      return setTableData((state) => [...state.slice(0, -2), totalData])
    }
    setIsShowConfirmDelete(true)
    setRequestDeleteData(rowData)
  }

  const handleOnConfirmDelete = () => {
    setIsShowConfirmDelete(false)
    handleCallApiDeleteCost(requestDeleteData)
  }

  const renderSaveButtonGroup = (rowData, _handleSave, _handleEdit) => {
    return (
      <>
        <IconButton
          appearance="ghost"
          icon={<Icon icon={isMulti ? 'check' : 'save'} className="bt-gost-icon-radius" />}
          onClick={handleSubmit((data) => _handleSave(data, rowData))}
          size="sm"
        >
          {isMulti ? 'ยืนยัน' : 'บันทึก'}
        </IconButton>
        <IconButton
          appearance="ghost"
          className="rs-btn-ghost-cancel"
          style={{ marginLeft: 5 }}
          icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
          onClick={() => {
            _handleEdit(rowData)
          }}
          size="sm"
        >
          ยกเลิก
        </IconButton>
      </>
    )
  }

  const handleMultiSave = () => {
    let isError
    let errorText = 'กรุณายันยันรายการที่แก้ไขค้างไว้ก่อน'

    tableData.forEach((element) => {
      if (element.status == 'EDIT') {
        notification.open('error', {
          title: errorText,
          duration: 10000,
        })
        isError = true
        return
      } else {
        element?.children?.forEach((subElement) => {
          if (subElement.status == 'EDIT') {
            notification.open('error', {
              title: errorText,
              duration: 10000,
            })
            isError = true
            return
          } else {
            subElement?.children?.forEach((sub2Element) => {
              if (sub2Element.status == 'EDIT') {
                notification.open('error', {
                  title: errorText,
                  duration: 10000,
                })
                isError = true
                return
              }
            })
          }
        })
      }
    })

    if (!isError) {
      onMultiSave(tableData)
    }
  }

  const findDefaultDate = (rowData, tableData, isStartDate) => {
    var date
    if (rowData.startDate) {
      date = moment(rowData.startDate, 'DD/MM/YYYY').toDate()
    } else {
      let previousInstallmentDate
      tableData?.length > 0 &&
        tableData.forEach((item, index) => {
          if (item.id === rowData.id) {
            let _index = isStartDate ? index - 1 : index + 1
            if (isStartDate && tableData[_index]?.endDate) {
              const prevEndDate = moment(tableData[_index].endDate, "DD/MM/YYYY");
              const newDate = prevEndDate.add(1, 'days');
              previousInstallmentDate = newDate.format('DD/MM/YYYY');
            } else {
              previousInstallmentDate = false
            }
          }
        })
      if (!previousInstallmentDate) {
        previousInstallmentDate = startProjectDate
      }
      date = moment(previousInstallmentDate, 'DD/MM/YYYY').toDate()
    }
    return date
  }

  const findStartDate = (rowData, tableData) => {
    var date = startProjectDate
    tableData?.length > 0 &&
      tableData.forEach((item, index) => {
        if (item.id === rowData.id && tableData[index - 1]?.endDate) {
          const prevEndDate = moment(tableData[index - 1]?.endDate, "DD/MM/YYYY");
          const newDate = prevEndDate.add(1, 'days');
          date = newDate.format('DD/MM/YYYY')
        }
      })
    return date
  }

  const findEndDate = (rowData, tableData) => {
    var date = endProjectDate
    tableData?.length > 0 &&
      tableData.forEach((item, index) => {
        if (item.id === rowData.id && tableData[index + 1]?.startDate) {
          date = tableData[index + 1]?.startDate
        }
      })
    return date
  }

  return (
    <div className="period-expenses">
      <br/>
      {isValidateBudget && <h6>{`งบประมาณ ${activityBudget ? budgetFormat(parseFloat(activityBudget)) : 0} บาท`}</h6>}
      <br/>
      <Panel header={header} bordered collapsible defaultExpanded>
        {tableData && (
          <Form className="form-table">
            <Table
              isTree
              expandedRowKeys={expandedRowKeys}
              onExpandChange={(expanded, rowData) => {
                if (expanded) {
                  setExpandedRowKeys((state) => [...state, rowData.id])
                } else {
                  setExpandedRowKeys((state) => state.filter((item) => item !== rowData.id))
                }
              }}
              rowKey="id"
              autoHeight
              data={tableData}
              shouldUpdateScroll={false}
              rowHeight={(rowData) => (rowData?.isDetail ? 210 : 64)}
            >
              <Column minWidth={115} colSpan={6} flexGrow={1}>
                <HeaderCell>งวดเงิน </HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData._parent?._parent && rowData.isDetail) {
                      return (
                        <EditEditorCell
                          rowData={rowData}
                          dataKey={rowData.label ? 'label' : 'list'}
                          register={register}
                          control={control}
                        />
                      )
                    }
                    return (
                      <span className={classNames(rowData.isTotal && 'total-summary')}>
                        {rowData.label || rowData.list}
                      </span>
                    )
                  }}
                </Cell>
              </Column>

              {/* <Column width={132} align="center">
                <HeaderCell>ปีงบประมาณ</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (!rowData._parent && !rowData.isTotal) {
                      return (
                        <EditYearCell
                          id={`year_${rowData.id}`}
                          rowData={rowData}
                          dataKey="year"
                          register={register}
                          control={control}
                          errors={errors}
                        />
                      )
                    }
                    return null
                  }}
                </Cell>
              </Column> */}

              <Column width={180} align="center">
                <HeaderCell>วันที่เริ่มต้น</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (!rowData._parent && rowData.children) {
                      let _startProjectDate = findStartDate(rowData, tableData)
                      let _endProjectDate = findEndDate(rowData, tableData)
                      let defaultDate = findDefaultDate(rowData, tableData, true)
                      return (
                        <EditDateCell
                          id={`startDate_${rowData.id}`}
                          rowData={rowData}
                          startProjectDate={startProjectDate}
                          endProjectDate={endProjectDate}
                          dataKey="startDate"
                          register={register}
                          control={control}
                          errors={errors}
                          startDate={_startProjectDate}
                          endDate={_endProjectDate}
                          defaultDate={defaultDate}
                        />
                      )
                    }
                    return null
                  }}
                </Cell>
              </Column>

              <Column width={180} align="center">
                <HeaderCell>วันที่สิ้นสุด</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData.isDetail) {
                      return null
                    }
                    if (!rowData._parent && rowData.children) {
                      let _startProjectDate = findStartDate(rowData, tableData)
                      let _endProjectDate = findEndDate(rowData, tableData)
                      let defaultDate
                      if (rowData.endDate) {
                        defaultDate = moment(rowData.endDate, 'DD/MM/YYYY').toDate()
                      } else {
                        defaultDate = moment(_endProjectDate, 'DD/MM/YYYY').toDate()
                      }
                      return (
                          <EditDateCell
                            id={`endDate_${rowData.id}`}
                            rowData={rowData}
                            // startProjectDate={startProjectDate}
                            // endProjectDate={endProjectDate}
                            dataKey="endDate"
                            register={register}
                            control={control}
                            errors={errors}
                            startDate={_startProjectDate}
                            endDate={_endProjectDate}
                            defaultDate={defaultDate}
                          />
                      )
                    }
                    return null
                  }}
                </Cell>
              </Column>

              <Column width={180} align="center">
                <HeaderCell>กำหนดส่งมอบ</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (!rowData._parent) {
                      let _startProjectDate = findStartDate(rowData, tableData)
                      let _endProjectDate = findEndDate(rowData, tableData)
                      let defaultDate
                      if (rowData.endDate) {
                        defaultDate = moment(rowData.endDate, 'DD/MM/YYYY').toDate()
                      } else {
                        defaultDate = moment(_endProjectDate, 'DD/MM/YYYY').toDate()
                      }
                      return (
                        <EditDateCell
                          id={`date_${rowData.id}`}
                          rowData={rowData}
                          // startProjectDate={startProjectDate}
                          // endProjectDate={endProjectDate}
                          dataKey="date"
                          register={register}
                          control={control}
                          errors={errors}
                          startDate={_startProjectDate}
                          endDate={_endProjectDate}
                          defaultDate={rowData['date'] ? moment(rowData['date'], 'DD/MM/YYYY').toDate() : defaultDate}
                        />
                      )
                    }
                    return null
                  }}
                </Cell>
              </Column>

              {/* <Column minWidth={230} flexGrow={1}>
                  <HeaderCell>รายละเอียดค่าใช้จ่าย</HeaderCell>
                  <Cell dataKey="label" />
                </Column> */}

              {/* <Column width={50} align="right">
                <HeaderCell>vat</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (
                      (rowData.children && rowData.children[0].isDetail) ||
                      rowData.isDetail ||
                      !rowData._parent?._parent
                    ) {
                      return
                    }
                    return <span>{`${rowData.vat} %`}</span>
                  }}
                </Cell>
              </Column> */}

              {/* <Column width={100} align="right">
                <HeaderCell>ภาษี ณ ที่จ่าย</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if(rowData.isDetail){
                      return
                    }
                    return <span>{budgetFormat(rowData.withholdingTax)}</span>
                    // console.log('rowData', rowData)
                    // if (
                    //   (rowData.children && rowData.children[0].isDetail) ||
                    //   rowData.isDetail ||
                    //   !rowData._parent?._parent
                    // ) {
                    //   return
                    // }
                    // return <span>{`${rowData.tax} %`}</span>
                  }}
                </Cell>
              </Column> */}

              <Column width={152} minWidth={120} flexGrow={isAssociate ? 1 : 0} align="right">
                <HeaderCell>จำนวนเงิน</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData.isNewVersion) {
                    } else if (
                      (rowData.children && rowData.children[0]?.isDetail) ||
                      rowData?.isDetail
                    ) {
                      return
                    } else if (rowData.isTotal) {
                      return (
                        <span className={'cost-total-summary'}>
                          {`${budgetFormat(getTotalSummary(tableData))}`}
                        </span>
                      )
                    } else if (!rowData._parent && rowData.children) {
                      return (
                        <span className={'cost-summary'}>
                          {budgetFormat(rowData.cost || rowData.installmentAmount)}
                        </span>
                      )
                    } else if (!rowData._parent._parent) {
                      return (
                        <span>
                          <b>{budgetFormat(rowData.cost || rowData.installmentAmount) || 0}</b>
                        </span>
                      )
                    }
                    return (
                      <EditNumberCell
                        id={`cost_${rowData.id}`}
                        rowData={rowData}
                        dataKey={rowData.cost || rowData.cost === 0 ? 'cost' : 'installmentAmount'}
                        register={register}
                        control={control}
                        errors={errors}
                        isBudgetFormat={true}
                      />
                    )
                  }}
                </Cell>
              </Column>

              {isWithdrawRequestSub && (
                <Column width={120} minWidth={120} flexGrow={isAssociate ? 1 : 0} align="right">
                  <HeaderCell>จ่ายจริง</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      if (rowData.withdrawAmount) {
                        return (
                          <Controller
                            name={rowData.withdrawByCateId}
                            key={rowData.withdrawByCateId}
                            control={widgetControl}
                            defaultValue={rowData.withdrawAmount.value || rowData.installmentAmount}
                            rules={isValidators(rowData.withdrawAmount.validators)}
                            //rules={{ required: 'กรุณากรอกจำนวนเงิน' }}
                            render={(props) => {
                              return (
                                <NumberFormat
                                  className={classNames(
                                    'rs-input',
                                    widgetErrors[rowData.withdrawByCateId] && 'is-error'
                                  )}
                                  thousandSeparator={true}
                                  value={props.value}
                                  onValueChange={(value) => {
                                    props.onChange(value.floatValue)
                                    onWithdrawAmountChange(rowData, value.floatValue)
                                  }}
                                  disabled={disabledForm}
                                />
                              )
                            }}
                          />
                        )
                      }
                    }}
                  </Cell>
                </Column>
              )}

              {isEditable && !isWithdrawRequestSub && (
                <Column width={230} align="center" fixed="right">
                  <HeaderCell>แก้ไข</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      if (rowData.isTotal) {
                        return null
                      }
                      if (rowData._parent && !rowData.children) {
                        if (rowData.status === 'EDIT') {
                          return renderSaveButtonGroup(rowData, handleSave, handleEditState)
                        } else {
                          const parent = rowData.isDetail
                            ? rowData._parent._parent
                            : rowData._parent._parent
                          return (
                            <IconButton
                              ppearance="ghost"
                              className="rs-btn-ghost-edit"
                              icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                              onClick={() => {
                                handleEditState(rowData)
                              }}
                              disabled={parent.disabled || !parent.date || !parent.year || disabledForm}
                              size="sm"
                            >
                              แก้ไข
                            </IconButton>
                          )
                        }
                      } else if (!rowData._parent) {
                        if (rowData.status === 'EDIT') {
                          return renderSaveButtonGroup(
                            rowData,
                            handleSaveYearAndDate,
                            handleEditYearAndDate
                          )
                        } else {
                          return (
                            <>
                              <IconButton
                                appearance="ghost"
                                className="rs-btn-ghost-edit"
                                icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                                onClick={() => handleEditYearAndDate(rowData)}
                                disabled={rowData.disabled || disabledForm}
                                size="sm"
                              >
                                แก้ไข
                              </IconButton>
                              {rowData.id === tableData[tableData.length - 2].id && (
                                <IconButton
                                  appearance="ghost"
                                  className="rs-btn-ghost-cancel"
                                  style={{ marginLeft: 5 }}
                                  icon={
                                    <Icon icon="trash-o" className="bt-gost-icon-radius-cancel" />
                                  }
                                  onClick={() => handleDelete(rowData)}
                                  disabled={rowData.disabled || disabledForm}
                                  size="sm"
                                >
                                  ลบ
                                </IconButton>
                              )}
                            </>
                          )
                        }
                      }
                      return null
                    }}
                  </Cell>
                </Column>
              )}
            </Table>
          </Form>
        )}
        {isEditable && (
          <>
            <br />
            <IconButton
              appearance="ghost"
              icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
              onClick={handleOnClickAddNewData}
              disabled={
                (!isEmpty(tableData) &&
                  tableData.length > 1 &&
                  !tableData[tableData.length - 2].year) ||
                disabledForm
              }
            >
              {'เพิ่มงวดเงิน'}
            </IconButton>
          </>
        )}

        {isMulti && (
          <>
            <hr />
            <Button appearance="ghost" onClick={handleMultiSave}>
              {'บันทึกงวดเงินไปยังทุกโครงการ'}
            </Button>
          </>
        )}
      </Panel>
      <ConfirmWidget
        title={`ยืนยันการลบงวดเงิน`}
        show={isShowConfirmDelete}
        detail={`กรุณายืนยันการลบงวดเงิน`}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleOnConfirmDelete}
      />
    </div>
  )
}
